import { Box } from "@mui/material";
import React from "react";
import { colors } from "../../theme/colors";

type IconContainerProps = {
  children: React.ReactNode;
  size?: number | string;
  bgcolor?: string;
  borderRadius?: string;
};

const IconContainer: React.FC<IconContainerProps> = ({
  children,
  size = 34,
  bgcolor = colors.background.default,
  borderRadius = "8px",
}) => {
  return (
    <Box
      sx={{
        width: size,
        height: size,
        bgcolor,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: borderRadius,
      }}
    >
      {children}
    </Box>
  );
};

export default IconContainer;
